import React, { useContext } from 'react';

import { Modal } from '@mui/material/';
import { Trans, useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '../../../assets/icons/close-icon.svg';
import { ModalContext } from '../../context/modal/modalContext';
import CustomBackdrop, { ICustomBackdropProps } from '../CustomBackdrop/CustomBackdrop';
import StyledButton from '../StyledButton/StyledButton';
import StyledButtonNE from '../StyledButtonNE/StyledButtonNE';

import './StyledModal.scss';

const StyledModal = () => {
  const { modal, modalContent, loading, handleCloseModal } = useContext(ModalContext);
  const { t } = useTranslation();
  const {
    expression,
    title,
    description,
    dictionary,
    primaryButton,
    secondaryButton,
    newExperience,
    ImageComponent,
    imageSrc,
    subtitle
  } = modalContent;

  return (
    <Modal
      open={modal}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      onClose={handleCloseModal}
      disableScrollLock={false}
      slots={{ backdrop: CustomBackdrop }}
      slotProps={{ backdrop: { handleClose: handleCloseModal } as ICustomBackdropProps }}
    >
      {newExperience ? (
        <div className="ne-modal-container">
          <CloseIcon className="ne-modal-close" onClick={handleCloseModal} name="close-generic-modal-button" />
          <div className="ne-modal-content">
            <div className="ne-modal-image-container">
              {ImageComponent && <ImageComponent className="ne-modal-icon" />}
              {imageSrc && <img className="ne-modal-image" src={imageSrc} alt="Modal immage" />}
            </div>
            <div className="ne-modal-text-container">
              <div className="ne-modal-title-container ">
                {title && <div className="ne-modal-title">{t(title)}</div>}
                {subtitle && <div className="ne-modal-subtitle">{t(subtitle)}</div>}
              </div>
              {description && (
                <div className="ne-modal-description">
                  {
                    <Trans
                      i18nKey={t(description)}
                      components={{
                        b2bBr: <br />
                      }}
                    />
                  }
                </div>
              )}
            </div>
            <div className="ne-modal-button-container">
              {primaryButton && (
                <div className="ne-modal-button">
                  <StyledButtonNE
                    buttonType={'primary'}
                    buttonSize="md"
                    action={primaryButton.action ?? handleCloseModal}
                    classes={primaryButton.classes}
                    loading={loading}
                  >
                    {t(primaryButton.text)}
                  </StyledButtonNE>
                </div>
              )}
              {secondaryButton && (
                <div className="ne-modal-button">
                  <StyledButtonNE
                    action={secondaryButton.action ?? handleCloseModal}
                    buttonType="secondary"
                    buttonSize="md"
                    classes={secondaryButton.classes}
                    disabled={loading}
                  >
                    {t(secondaryButton.text)}
                  </StyledButtonNE>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="modal-container">
          <div className="modal-content">
            <CloseIcon className="modal-close hide-mobile" onClick={handleCloseModal} />
            {(expression || title) && (
              <div className="modal-title-container">
                {expression && <div className="modal-main-title">{t(expression)}</div>}
                {title && <div className="modal-secondary-title">{t(title)}</div>}
              </div>
            )}
            {description && (
              <div
                className="modal-description"
                dangerouslySetInnerHTML={{ __html: dictionary ? t(description, dictionary) : t(description) }}
              ></div>
            )}
            {primaryButton && (
              <div className="modal-button-container">
                <div className="modal-button">
                  <StyledButton
                    action={primaryButton.action ?? handleCloseModal}
                    buttonType="primary"
                    buttonSize="md"
                    classes={primaryButton.classes}
                    loading={loading}
                  >
                    {t(primaryButton.text)}
                  </StyledButton>
                </div>
                {secondaryButton && (
                  <div className="modal-button last">
                    <StyledButton
                      action={secondaryButton.action ?? handleCloseModal}
                      buttonType="secondary"
                      buttonSize="md"
                      classes={secondaryButton.classes}
                      disabled={loading}
                    >
                      {t(secondaryButton.text)}
                    </StyledButton>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default StyledModal;
